module.exports = __webpack_public_path__ + "img/watch-4.d4fe6e8f.png";